<template>
  <div :class="computedClasses" :style="{ width: `${size}px`, height: `${size}px`, background }" class="tutor-icon">
    <div class="tutor-icon__icon" :style="{ width: `${computedWidth}px`, height: `${computedHeight}px` }">
      <svg
        :height="computedHeight" :width="computedWidth" fill="none" viewBox="0 0 26 32"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.5274 10.4298C16.304 10.4298 18.5548 8.17899 18.5548 5.40242C18.5548 2.62585 16.304 0.375 13.5274 0.375C10.7509 0.375 8.5 2.62585 8.5 5.40242C8.5 8.17899 10.7509 10.4298 13.5274 10.4298Z"
          fill="#141416"/>
        <path
          d="M3.24223 9.9724C1.87112 9.51537 0.5 10.4294 0.5 11.8006V23.2265C0.5 24.1406 0.957038 24.8262 1.6426 25.0547L12.6115 29.3965V13.8572L3.24223 9.9724ZM9.64077 22.541C9.41225 22.7695 9.18373 22.998 8.95521 22.998H8.7267L4.15631 21.3984C3.69927 21.1698 3.47075 20.7128 3.69927 20.2558C3.92779 19.7987 4.38483 19.5702 4.84187 19.7987L9.41225 21.3984C9.41225 21.6269 9.64077 22.0839 9.64077 22.541ZM9.64077 19.1132C9.41225 19.3417 9.18373 19.5702 8.95521 19.5702H8.7267L4.15631 17.9706C3.69927 17.7421 3.47075 17.285 3.69927 16.828C3.92779 16.3709 4.38483 16.1424 4.84187 16.3709L9.41225 17.9706C9.41225 18.1991 9.64077 18.6561 9.64077 19.1132Z"
          fill="#141416"/>
        <path
          d="M23.8087 9.97312L14.2109 13.8579V29.6258L25.1799 25.2839C25.8654 25.0554 26.3225 24.1413 26.3225 23.4557V12.0298C26.551 10.4302 24.9513 9.51608 23.8087 9.97312ZM22.8947 21.3991L18.3243 22.9987H18.0958C17.8672 22.9987 17.4102 22.7702 17.4102 22.5417C17.1817 22.0846 17.4102 21.6276 17.8672 21.3991L22.4376 19.7994C22.8947 19.5709 23.3517 19.7994 23.5802 20.2565C23.5802 20.7135 23.3517 21.1706 22.8947 21.3991ZM22.8947 17.9713L18.3243 19.5709H18.0958C17.8672 19.5709 17.4102 19.3424 17.4102 19.1139C17.1817 18.6568 17.4102 18.1998 17.8672 17.9713L22.4376 16.3717C22.8947 16.1431 23.3517 16.3717 23.5802 16.8287C23.8087 17.2857 23.3517 17.7428 22.8947 17.9713Z"
          fill="#141416"/>
      </svg>

    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  size?: number | string
  variant?: string
  background?: string
}>(), {
  size: 40,
  variant: 'normal',
  background: 'transparent',
})

const computedWidth = computed(() => Number(props.size) * 0.5)
const computedHeight = computed(() => Number(props.size) * 0.5)

const classBorder = computed(() => Number(props.size) <= 30 ? 'thin' : null)
const classVariant = computed(() => props.variant === 'normal' ? 'normal' : 'dark')

const computedClasses = computed(() => [classVariant.value, classBorder.value])
</script>

<style lang="scss" scoped>
.tutor-icon {
  position: relative;
  border-radius: 50%;
  border: 3px solid transparent;
  background-clip: padding-box;

  .tutor-icon__icon, .tutor-icon__icon > svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  svg path {
    fill: var(--neutral-white) !important;
  }

  &.normal {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      padding: 3px;
      background: linear-gradient(180deg, #EE7DFF 0%, #9ACEFF 52%, #3D9AF2 100%);
      mask: linear-gradient(#000 0 0) content-box,
      linear-gradient(#000 0 0);
      mask-composite: exclude;
    }
  }

  &.dark {
    border-color: var(--neutral-gray-900);
  }

  &.thin {
    border-width: 2px;

    &::before {
      padding: 2px;
    }
  }

  &::after {
    display: none !important;
    background: none !important;
    height: 0 !important;
  }
}

[data-theme="light"] {
  .tutor-icon {
    svg path {
      fill: var(--neutral-gray-900) !important;
    }
  }
}
</style>
